import { render, staticRenderFns } from "./ProfitCenterAdditionalFieldsPage.vue?vue&type=template&id=1a9fad4f&scoped=true&lang=pug&"
import script from "./ProfitCenterAdditionalFieldsPage.vue?vue&type=script&lang=ts&"
export * from "./ProfitCenterAdditionalFieldsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9fad4f",
  null
  
)

export default component.exports